/**
 * Canonical list of client routes that are served to anonymous visitors.
 *
 * Kept in sync with the "Public routes" block in App.tsx. On these paths the
 * app must NOT:
 *  - trigger OIDC silent-signin on bootstrap
 *  - force-logout (which calls signinRedirect) on a 401 from a background
 *    request (e.g. a stale-token boot call), since that hijacks the visit
 *    and bounces the visitor to /Account/Login.
 *
 * A trailing "/" prefix comparison is used so that parameterized routes like
 * `/p/<slug>` are covered by a single entry `/p/`.
 */
const PUBLIC_PATH_PREFIXES = [
  '/p/',                  // /p/<slug>                — public profile display
  '/logincallback',       // OIDC redirect URI
  '/silent-renew',        // OIDC silent-renew iframe
  '/logoutcallback',      // OIDC post-logout redirect
  '/signuptrial',         // legacy alias — redirects to /signup
  '/signup-trial',        // legacy alias — redirects to /signup
  '/signup',              // Free-tier self-serve signup
  '/privacypolicy',       // legal
  '/unsubscribe',         // email unsubscribe
  '/widget',              // embeddable widget
] as const;

export function isPublicRoute(pathname?: string): boolean {
  const path = (pathname ?? (typeof window !== 'undefined' ? window.location?.pathname : '')) || '';
  return PUBLIC_PATH_PREFIXES.some(prefix =>
    prefix.endsWith('/') ? path.startsWith(prefix) : path === prefix
  );
}
